export enum ResultadoPruebaDeAgua {
    Positiva = 0,
    Negativa = 1
}
